import { render, staticRenderFns } from "./EditDayPhoto.vue?vue&type=template&id=5223b84e&scoped=true&"
import script from "./EditDayPhoto.vue?vue&type=script&lang=js&"
export * from "./EditDayPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223b84e",
  null
  
)

export default component.exports